module.exports = __webpack_public_path__ + "fb75dbb90cc28e8083354be67012c208.png";